/**
 * ZAXIA API Configuration
 * Centralized API URL configuration for all frontend modules
 * 
 * Usage:
 *   import { API_BASE } from '@/config/api';
 *   fetch(`${API_BASE}/endpoint`);
 * 
 * Environment Variables:
 *   VITE_API_URL - Full API base URL (e.g., https://api.zaxia.ai/api)
 * 
 * Defaults:
 *   Development: http://localhost:3001/api
 *   Production: /api (assumes reverse proxy)
 */

function getApiBaseUrl(): string {
  // 1. Explicit env variable takes priority
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }

  // 2. Development fallback
  if (import.meta.env.DEV) {
    return 'http://localhost:3001/api';
  }

  // 3. Production fallback (relative URL, works with reverse proxy)
  return '/api';
}

/**
 * Base URL for all API requests
 * Configured via VITE_API_URL environment variable
 */
export const API_BASE = getApiBaseUrl();

/**
 * Log config on startup (dev only)
 */
if (import.meta.env.DEV) {
  console.log('[ZAXIA Config] API_BASE:', API_BASE);
}
